import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingController, NavController } from '@ionic/angular';
import { CommonService } from 'src/app/common/common.service';

@Component({
  selector: 'timetable',
  templateUrl: './timetable.component.html',
  styleUrls: ['./timetable.component.scss'],
})
export class TimetableComponent implements OnInit {

  eventSource: any;
  viewTitle;
  isToday: boolean;
  errorMsg: any;
  calendar = {
    mode: 'month',
    currentDate: new Date()
  };
  pagestateUrl;
  course: any;
  user: any = null;
  announcements = [];
  courses = [];
  pk_course_id: number;

  @Input() timetable = [];


  constructor(
    private service: CommonService,
    private navCtrl: NavController,
    private router: Router,
    private route: ActivatedRoute,
    private loadingCtrl: LoadingController,
  ) {

    this.course = JSON.parse(localStorage.getItem('myprofile'))?.student_course[0];
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.getAttendenceBatch();

    this.route.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation()?.extras?.state) {
        this.pagestateUrl = this.router.getCurrentNavigation().extras.state.stateUrl;
      }
    });
  }

  

  ngOnInit() {
    
  }

  async getCourses(){
    this.service.getStudentCourses(this.user.student_id)
      .subscribe(result => {
        this.courses = this.service.removeDuplicates(result.Items, 'pk_course_id');
        this.pk_course_id = this.courses[0].pk_course_id;
          this.getTimetable();
      },(error)=>{
        this.service.showToast('Oops! Something went wrong. Please try again later.');
      });
  }

  batchid: number;

  async getAttendenceBatch() {
    this.service.getAttendenceBatch(this.user.student_id).subscribe((result) => {
      this.batchid = result.Items[0].batch_name;
      console.log(this.batchid);
      this.getCourses();

    });
  }


  async getTimetable() { 
    this.service.getTimetable(this.pk_course_id, this.batchid).subscribe(result => {
      this.timetable = result;
    },(error)=>{
      this.service.showToast('Oops! Something went wrong. Please try again later.');
    });
  }
}
